import React from 'react'
import { useTranslation } from "react-i18next";

export default function Billing() {
  const { t } = useTranslation();
  return (
    <div>{t("billing")}</div>
  )
}
